import { BundleFlightData } from '../../modules/FlightDetails/flightSlice';
import { OptionalFilter } from '../../components/SideFilters/interface';

export interface SupplierError {
  ts_id: number;
  ts_type?: string;
  error: string;
}

export enum AsyncSearchStatus {
  Idle = 'idle',
  LoadingAll = 'loading_all',
  FirstChunkReceived = 'first_chunk_received',
  Streaming = 'streaming',
  Complete = 'complete',
  Error = 'error',
}

export interface FlightAsyncState {
  // State machine
  status: AsyncSearchStatus;

  // Results accumulation
  flights: BundleFlightData[];
  /** Flights prepended from SKY chunks — prefix length for price sort on complete */
  priorityFlightCount: number;

  // Supplier tracking
  expectedSuppliers: number;
  returnedSuppliers: number;
  supplierErrors: SupplierError[];

  // Client-built filters
  optionalFilters: OptionalFilter[];

  // Error
  error: string | null;

  // Search metadata
  searchStartTime: number | null;
  searchEndTime: number | null;

  // Progress tracking from SSE
  totalCount: number;
  successCount: number;
  errorCount: number;
}

export interface FlightDynamicAsyncState {
  // Outbound flight state
  outbound: {
    status: AsyncSearchStatus;
    flights: BundleFlightData[];
    priorityFlightCount: number;
    returnedSuppliers: number;
    supplierErrors: SupplierError[];
    optionalFilters: OptionalFilter[];
    error: string | null;
    searchStartTime: number | null;
    searchEndTime: number | null;
    totalCount: number;
    successCount: number;
    errorCount: number;
  };
  // Return flight state
  return: {
    status: AsyncSearchStatus;
    flights: BundleFlightData[];
    priorityFlightCount: number;
    returnedSuppliers: number;
    supplierErrors: SupplierError[];
    optionalFilters: OptionalFilter[];
    error: string | null;
    searchStartTime: number | null;
    searchEndTime: number | null;
    totalCount: number;
    successCount: number;
    errorCount: number;
  };
}
